import { actions } from '@sloyd/store-base';
import { put, takeEvery } from 'saga-ts';
import { invokeEvent, l } from 'shared-base';
import { customEventChannel } from './channels/channel.customEvent';

// Fetch data from multiple API endpoints
export function* onLog(ev: any): Generator<any, void, any> {
  try {
    const { data } = ev;
    yield put(actions.logs.patch(data.id, data));
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

// Root saga
export function* root(): Generator<any, void, any> {
  l('saga|saga.logs listening for sloyd/log custom event');
  const channel = customEventChannel('sloyd/log');
  yield takeEvery(channel, onLog);
}

// Export saga
export const saga = {
  id: 'sloyd.logs',
  type: 'bootstrap',
  root,
  trigger: {},
};
